import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1 className="page-title">Privacy Policy</h1>
        <p className="policy-date">Last updated: 1 January 2026</p>

        <section className="policy-section">
          <h2>1. Introduction</h2>
          <p>World Financial Award Ltd ("we", "us", "our") is committed to protecting and respecting your privacy. This policy sets out the basis on which any personal data we collect from you, or that you provide to us, will be processed by us in accordance with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.</p>
          <p>Our registered office is located in London, United Kingdom. For the purpose of data protection legislation, we are the data controller.</p>
        </section>

        <section className="policy-section">
          <h2>2. Information We Collect</h2>
          <p>We may collect and process the following personal data:</p>
          <ul>
            <li><strong>Identity Data:</strong> Full name, title, company name, job title.</li>
            <li><strong>Contact Data:</strong> Email address, telephone number, postal address.</li>
            <li><strong>Technical Data:</strong> IP address, browser type, operating system, referring URLs, and information about your visit to our website.</li>
            <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
            <li><strong>Marketing Data:</strong> Your preferences in receiving marketing from us and your communication preferences.</li>
            <li><strong>Competition Data:</strong> Information submitted as part of your award nomination or competition entry.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use your personal data for the following purposes:</p>
          <ul>
            <li>To process and manage your award nominations and competition entries.</li>
            <li>To communicate with you regarding the World Financial Award ceremony and events.</li>
            <li>To send you newsletters and marketing communications where you have consented.</li>
            <li>To administer and improve our website and services.</li>
            <li>To comply with legal or regulatory obligations.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Lawful Basis for Processing</h2>
          <p>We process your personal data on the following legal bases under the UK GDPR:</p>
          <ul>
            <li><strong>Consent (Article 6(1)(a)):</strong> Where you have given clear consent for us to process your personal data for a specific purpose, such as marketing communications.</li>
            <li><strong>Contract (Article 6(1)(b)):</strong> Where processing is necessary for the performance of a contract with you, such as processing your competition entry.</li>
            <li><strong>Legitimate Interests (Article 6(1)(f)):</strong> Where processing is necessary for our legitimate business interests, provided these are not overridden by your rights.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Data Sharing</h2>
          <p>We do not sell your personal data. We may share your data with:</p>
          <ul>
            <li>Service providers who assist us in operating our website and conducting our business (e.g., hosting providers, email services).</li>
            <li>Professional advisers including lawyers, auditors, and insurers.</li>
            <li>Regulatory authorities, where required by law.</li>
          </ul>
          <p>All third parties are required to respect the security of your personal data and to treat it in accordance with applicable law.</p>
        </section>

        <section className="policy-section">
          <h2>6. International Transfers</h2>
          <p>Where we transfer your personal data outside of the United Kingdom, we ensure that appropriate safeguards are in place in accordance with UK data protection legislation, including the use of Standard Contractual Clauses approved by the Information Commissioner's Office (ICO).</p>
        </section>

        <section className="policy-section">
          <h2>7. Data Retention</h2>
          <p>We will retain your personal data only for as long as necessary to fulfil the purposes for which it was collected, including to satisfy any legal, accounting, or reporting requirements. Competition entry data is retained for a maximum of 3 years following the relevant ceremony year.</p>
        </section>

        <section className="policy-section">
          <h2>8. Your Rights</h2>
          <p>Under the UK GDPR, you have the following rights:</p>
          <ul>
            <li>The right to access your personal data.</li>
            <li>The right to rectification of inaccurate data.</li>
            <li>The right to erasure ("right to be forgotten").</li>
            <li>The right to restrict processing.</li>
            <li>The right to data portability.</li>
            <li>The right to object to processing.</li>
            <li>The right to withdraw consent at any time.</li>
          </ul>
          <p>To exercise any of these rights, please contact us at <a href="mailto:info@worldfinancialaward.com">info@worldfinancialaward.com</a>.</p>
        </section>

        <section className="policy-section">
          <h2>9. Complaints</h2>
          <p>If you are unhappy with how we have handled your personal data, you have the right to lodge a complaint with the Information Commissioner's Office (ICO):</p>
          <p>Information Commissioner's Office<br />Wycliffe House, Water Lane, Wilmslow, Cheshire, SK9 5AF<br />Website: <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">ico.org.uk</a><br />Telephone: 0303 123 1113</p>
        </section>

        <section className="policy-section">
          <h2>10. Contact Us</h2>
          <p>For any questions regarding this Privacy Policy, please contact:<br />
          World Financial Award Ltd<br />
          Email: <a href="mailto:info@worldfinancialaward.com">info@worldfinancialaward.com</a><br />
          London, United Kingdom</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
